import PropTypes from "prop-types";

export default PropTypes.shape({
  themePrimary: PropTypes.string, // Team Color (Video Player)
  themeSecondary: PropTypes.string, // Team Color (Header)
  themeTertiary: PropTypes.string, // Background Color
  themePrimaryText: PropTypes.string, // Text Color (Video Player)
  themeSecondaryText: PropTypes.string // Text Color (Header)
});
